import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";

function SelectJsonTypeValue({ setValue, value }: any) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const DATA = ["string", "number", "boolean"];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (newValue: string) => {
		setValue(newValue);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Select className='generalStyles__width100' size='small' onChange={onChange} value={value}>
			{DATA.map((item: string) => (
				<Option key={item} value={item}>
					{item}
				</Option>
			))}
		</Select>
	);
}

export default SelectJsonTypeValue;
